/*
 * Copyright (c) 2021-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: GeneralControlsTab.tsx
 * Project: mle-client-n
 * Committed last: 2022/3/4 @ 1814
 * ---
 * Description:
 */

import React                       from 'react';
import { ActiveTabProps }          from './CurrentSelectionPanel';
import { observer }                from 'mobx-react';
import { ControlGroupView }        from '../controls/ControlGroupView';
import { getGeneralControlGroup, } from '../../../common/controls';
import {
  GeneralControlGroupTypes
}                                  from '../../../common/controls/groups/general';

export const GeneralControlsTab = observer((props: ActiveTabProps) => {
  const renderControlGroups = () => {
    return Object.values(GeneralControlGroupTypes).map(controlGroupType => {
      return <ControlGroupView
        editor={ props.editor }
        controlGroup={ getGeneralControlGroup(
          (controlGroupType as GeneralControlGroupTypes),
          props.editor
        ) }
      />;
    });
  };

  return (
    <div>
      { renderControlGroups() }
    </div>
  );
});
